var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2394_4089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.25 7.64062V6.375C24.25 4.92525 23.0748 3.75 21.625 3.75H2.875C1.42525 3.75 0.25 4.92525 0.25 6.375V7.64062C0.25 7.77005 0.354953 7.875 0.484375 7.875H24.0156C24.145 7.875 24.25 7.77005 24.25 7.64062Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 9.60938V17.625C0.25 19.0747 1.42525 20.25 2.875 20.25H21.625C23.0748 20.25 24.25 19.0747 24.25 17.625V9.60938C24.25 9.47995 24.145 9.375 24.0156 9.375H0.484375C0.354953 9.375 0.25 9.47995 0.25 9.60938ZM6.25 15.75C6.25 16.1642 5.91419 16.5 5.5 16.5H4.75C4.33581 16.5 4 16.1642 4 15.75V15C4 14.5858 4.33581 14.25 4.75 14.25H5.5C5.91419 14.25 6.25 14.5858 6.25 15V15.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2394_4089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.053a3070834a5b495af365def461f092.svg";
export { ForwardRef as ReactComponent };